import React, { Component } from 'react';

import AdminLayout from './layout';

import { adminDashboard, showresultssearch } from '../../API/FetchCall';

import { Chart } from 'chart.js';

const doughnutPieOptions = {
          responsive: true,
          animation: {
            animateScale: true,
            animateRotate: true
          }
        };    

class dashboardV1 extends Component {

    constructor(props) {
        super(props);
        this.state = {
          school_data: []
        };
        this.findbest = this.findbest.bind(this);
    }

    componentDidMount() {

        let req = {
            url: 'school_data'
        };

        adminDashboard(JSON.stringify(req)).then(response => {
            if (response.status === 1) {
                this.setSchoolChart(response.result);
            }
        });

        let req_t = {
            url: 'tuition_data'
        };

        adminDashboard(JSON.stringify(req_t)).then(response => {
            if (response.status === 1) {
                this.setTuitionChart(response.result);
            }
        });


        let req_pre = {
            url: 'preschool_data'
        };

        adminDashboard(JSON.stringify(req_pre)).then(response => {
            if (response.status === 1) {
                this.setPreschoolChart(response.result);
            }
        });

        let req_afa = {
            url: 'afterschool_data'
        };

        adminDashboard(JSON.stringify(req_afa)).then(response => {
            if (response.status === 1) {
                this.setAfterschoolChart(response.result);
            }
        });      

        let req_camp = {
            url: 'camp_data'
        };

        adminDashboard(JSON.stringify(req_camp)).then(response => {
            if (response.status === 1) {
                this.setcampChart(response.result);
            }
        });   

        let req_com = {
            url: 'community_data'
        };

        adminDashboard(JSON.stringify(req_com)).then(response => {
            if (response.status === 1) {
                this.setcommunityChart(response.result);
            }
        });   

        let req_birthday = {
            url: 'birthday_data'
        };

        adminDashboard(JSON.stringify(req_birthday)).then(response => {
            if (response.status === 1) {
                this.setbirthdayChart(response.result);
            }
        });                   

    }

    handleChange = (e) => {
      this.setState({ [e.target.name]: e.target.value });
    };  
  

    findbest(){

        let req = {
          keyword: this.state.keyword
        };

        showresultssearch(JSON.stringify(req)).then(response => {
            if (response.status === 1) {
               this.setState({results:response.results});
            }else{
                this.setState({results:[]});
            }
        });

    }

    setAfterschoolChart = (data) => {

        var ctx = document.getElementById('afterschoolChart');
        new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    }    

    setTuitionChart = (data) => {

        var ctx = document.getElementById('tuitionChart');
        new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    }

    setSchoolChart = (data) => {

        var ctx = document.getElementById('schoolChart');
        new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    }

    setPreschoolChart = (data) => {

        var ctx = document.getElementById('preschoolChart');
        new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    } 


    setcampChart = (data) => {

        var ctx = document.getElementById('campChart');
        new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    }

    setcommunityChart = (data) => {

        var ctx = document.getElementById('communityChart');
        new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    }

    setbirthdayChart = (data) => {

        var ctx = document.getElementById('birthdayChart');
        new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    }        


    render() {

        return (
            <React.Fragment>
                <AdminLayout>
                    
                        <div class="row  mt-3">
              <div class="col-xl-8 d-flex grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex flex-wrap justify-content-between">
                      <h4 class="card-title mb-3">Vertical User Info</h4>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <div class="row">
                          <div class="col-lg-12">

                            <ul class="nav nav-tabs">
                              <li><a data-toggle="tab" href="#home">School</a></li>
                              <li><a data-toggle="tab" href="#preschoolCharts">Preschool</a></li>
                              <li><a data-toggle="tab" href="#tuitionCharts">Tuitions</a></li>
                              <li><a data-toggle="tab" href="#afaCharts">After School</a></li>
                              <li><a data-toggle="tab" href="#learnincampsCharts">Learning Camps</a></li>
                              <li><a data-toggle="tab" href="#communityCharts">Community Supports</a></li>
                              <li><a data-toggle="tab" href="#brithdayChart">Birthday Events</a></li>
                            </ul>
                            <div class="tab-content">
                              <div id="home" class="tab-pane fade in active">
                                  <div class="chartdisblock"><canvas id="schoolChart"></canvas></div>
                                  <div><a href="/vertical/school">Go to page</a></div>
                              </div>
                              <div id="preschoolCharts" class="tab-pane fade">
                                  <div class="chartdisblock"><canvas id="preschoolChart"></canvas></div>
                                  <div><a href="/vertical/preschool">Go to page</a></div>
                              </div>
                              <div id="tuitionCharts" class="tab-pane fade">
                                  <div class="chartdisblock"><canvas id="tuitionChart"></canvas></div>
                                  <div><a href="/vertical/tuitions">Go to page</a></div>
                              </div>
                              <div id="afaCharts" class="tab-pane fade">
                                  <div class="chartdisblock"><canvas id="afterschoolChart"></canvas></div>
                                  <div><a href="/vertical/afterschool">Go to page</a></div>
                              </div>
                              <div id="learnincampsCharts" class="tab-pane fade">
                                  <div class="chartdisblock"><canvas id="campChart"></canvas></div>
                                  <div><a href="/vertical/learningcamps">Go to page</a></div>
                              </div>
                              <div id="communityCharts" class="tab-pane fade">
                                  <div class="chartdisblock"><canvas id="communityChart"></canvas></div>
                                  <div><a href="/vertical/communitysupport">Go to page</a></div>
                              </div>
                              <div id="brithdayChart" class="tab-pane fade">
                                  <div class="chartdisblock"><canvas id="birthdayChart"></canvas></div>
                                  <div><a href="/vertical/birthdayevents">Go to page</a></div>
                              </div>
                            </div>
                            
                          </div>
                          
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-4 d-flex grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex flex-wrap justify-content-between">
                      <h4 class="card-title mb-3">Payments</h4>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <div class="mb-5">
                          <div class="mr-1">
                            <div class="text-info mb-1">
                              Total Payments Received
                            </div>
                            <h2 class="mb-2 mt-2 font-weight-bold">INR 2,87,493</h2>
                            <div class="font-weight-bold">
                              Since Last 6 Months
                            </div>
                          </div>
                          <hr />
                          
                        </div>
                        <canvas id="barChartStacked"></canvas>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
               
               

              <div class="col-xl-3 d-flex grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex flex-wrap justify-content-between">
                      <h4 class="card-title mb-3">Recent Payments Made</h4>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="d-flex justify-content-between mb-4">
                              <div class="font-weight-medium">Customer Name</div>
                              <div class="font-weight-medium">This Month</div>
                            </div>
                            <div class="d-flex justify-content-between mb-4">
                              <div class="text-secondary font-weight-medium">AIMS Institute</div>
                              <div class="small">19999 INR</div>
                            </div>
                             
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-4 d-flex grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex flex-wrap justify-content-between">
                      <h4 class="card-title mb-3">Recent Leads</h4>
                      
                    </div>
                    <div class="row">
                      <div class="col-12">
                        
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-4 d-flex grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex flex-wrap justify-content-between">
                      <h4 class="card-title mb-3">Recent Enquiries</h4>
                      
                    </div>
                    <div class="row">
                      <div class="col-12">
                         
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-12 d-flex grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex flex-wrap justify-content-between">
                      <h4 class="card-title mb-3">Find and Get Detailed Report</h4>
                      
                    </div>
                    <div class="row">
                      <div class="col-12">
                            <input type="text" name="keyword" class="form-input-cls" onChange={this.handleChange} placeholder='Type any text' /> <button class="btn btn-primary btn-sm" onClick={this.findbest}>Find</button>     
                      </div>
                      {this.state.results && this.state.results.length>0 &&
                      <div class="col-12">
                        <div class="results">
                            <div>We found below partners /institutions </div>

                            <ul class="result_items">
                              {this.state.results.map((item, index)=>{

                                return  <li><a href={"/dashboard/singlereport/"+item.vendor_id} target="_blank">{item.organisation_name}</a></li>

                              })}

                            </ul>
                        </div>
                      </div>
                      }

                      {this.state.results && this.state.results.length===0 &&
                          <div class="results">No data</div>
                      }
                    </div>
                  </div>
                </div>
              </div>

             
              <div class="col-lg-12 d-flex grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex flex-wrap justify-content-between">
                      <h4 class="card-title mb-3">Recent Artiles published (5)</h4>
                    </div>
                    <div class="table-responsive">
                      <table class="table">
                        <tbody>
                          <tr>
                            <td>
                              <div class="d-flex">
                                <img class="img-sm rounded-circle mb-md-0 mr-2" src="images/faces/face31.png" alt="profile" />
                                <div>
                                  <div> Best Sports in Bengaluru</div>
                                  <div class="font-weight-bold mt-1">Articles</div>
                                </div>
                              </div>
                            </td>
                            <td>
                              By
                              <div class="font-weight-bold  mt-1">Arpita</div>
                            </td>
                            <td>
                              Status
                              <div class="font-weight-bold text-success  mt-1">waiting for approval</div>
                            </td>
                            <td>
                              Created Date
                              <div class="font-weight-bold  mt-1">07 Nov 2019</div>
                            </td>
                            <td>
                              <button type="button" class="btn btn-sm btn-secondary">edit actions</button>
                            </td>
                          </tr>
                          
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>


              

            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default dashboardV1;


// WEBPACK FOOTER //
// ./src/components/bewise/dashboardV1.jsx